import { render, staticRenderFns } from "./proprietorNotificationList.vue?vue&type=template&id=7df02a71&"
import script from "./proprietorNotificationList.vue?vue&type=script&lang=js&"
export * from "./proprietorNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./proprietorNotificationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports